<div class="aa-shell" [class.dark]="isDark">
  <ngx-loading [show]="isLoading"></ngx-loading>

  <!-- ══ HUD BAR ══ -->
  <div class="aa-hud">
    <div class="aa-hud__left">
      <div class="aa-hud__icon-wrap">
        <fa-icon [icon]="faUser"></fa-icon>
      </div>
      <div class="aa-hud__title-block">
        <span class="aa-hud__eyebrow">ADMIN CONSOLE</span>
        <span class="aa-hud__title">{{ 'ADMIN_AGENTS_AUDIT.TITLE' | translate }}</span>
      </div>
    </div>
    <div class="aa-hud__right">
      <div class="aa-audit-count" *ngIf="audits.length">
        <span class="aa-audit-count__num">{{ audits.length }}</span>
        <span class="aa-audit-count__label">EVENTS</span>
      </div>
      <button class="aa-btn aa-btn--primary" type="button"
              (click)="onSearch()" [disabled]="isLoadingAudits">
        <mat-icon>search</mat-icon>
        <span>SEARCH</span>
      </button>
    </div>
  </div>

  <!-- ══ FILTERS ══ -->
  <div class="aa-filters">
    <div class="container-fluid px-0">
      <div class="row g-2 align-items-end">

        <div class="col-12 col-sm-6 col-lg-4">
          <app-agent-input-autocomplete
            [roles]="roles"
            [excludeMe]="!auth.isAdmin()"
            [teamLeadId]="auth.isAdmin() ? null : auth.userProfile.cognitoId"
            [withTeam]="!auth.isAdmin()"
            (selectionChange)="onChangeUser($event)"
            (agentsLoad)="onAgentsLoaded($event)"
            [placeholder]="'ADMIN_AGENTS_AUDIT.SELECT_AGENT.PLACEHOLDER' | translate"
            [placeholderLabel]="'ADMIN_REVIEW_FEEDBACK.SELECT_USER.INPUT_PLACEHOLDER' | translate"
          ></app-agent-input-autocomplete>
        </div>

        <div class="col-12 col-sm-6 col-lg-4">
          <app-activity-input-autocomplete
            (selectionChange)="onChangeActivity($event)"
            [placeholder]="'ADMIN_AGENTS_AUDIT.SELECT_ACTIVITY.PLACEHOLDER' | translate"
            [placeholderLabel]="'ADMIN_AGENTS_AUDIT.SELECT_ACTIVITY.INPUT_PLACEHOLDER' | translate"
          ></app-activity-input-autocomplete>
        </div>

        <div class="col-12 col-sm-12 col-lg-4">
          <div class="console-panel">
            <!-- Console Header -->
            <div class="console-panel__header d-flex align-items-center gap-2 mb-2">
              <span class="console-panel__led console-panel__led--green"></span>
              <span class="console-panel__led console-panel__led--yellow"></span>
              <span class="console-panel__led console-panel__led--red"></span>
              <span class="console-panel__title ms-2">DATE RANGE</span>
            </div>
            <!-- Console Screen -->
            <div class="console-panel__screen">
              <mat-form-field class="w-100 console-panel__field">
                <input matInput
                       [placeholder]="'ADMIN_AGENTS_AUDIT.DATE_PICKER_PLACEHOLDER' | translate"
                       [satDatepicker]="picker"
                       [(ngModel)]="date"
                       [max]="maxDate"
                       (keydown.enter)="onSearch()"
                       (dateChange)="onChangeDate()" />
                <sat-datepicker #picker [rangeMode]="true"></sat-datepicker>
                <sat-datepicker-toggle matSuffix [for]="picker"></sat-datepicker-toggle>
              </mat-form-field>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- ══ AUDIT LOG ══ -->
  <div class="aa-log-wrap">

    <!-- section header -->
    <div class="aa-log-header">
      <div class="aa-log-header__icon"><fa-icon [icon]="faList"></fa-icon></div>
      <span class="aa-log-header__title">{{ 'ADMIN_AGENTS_AUDIT.LIST_ACTIVITY_TITLE' | translate }}</span>
      <div class="aa-log-header__line"></div>
      <mat-progress-bar *ngIf="isLoadingAudits" mode="query" class="aa-inline-progress"></mat-progress-bar>
    </div>

    <!-- table header -->
    <div class="aa-table-head">
      <div class="aa-col aa-col--date">TIMESTAMP</div>
      <div class="aa-col aa-col--user">AGENT</div>
      <div class="aa-col aa-col--roles">ROLES</div>
      <div class="aa-col aa-col--activity">ACTIVITY</div>
      <div class="aa-col aa-col--actions"></div>
    </div>

    <!-- rows -->
    <div class="aa-table-body">

      <!-- empty state -->
      <div class="aa-empty" *ngIf="!isLoadingAudits && audits.length === 0">
        <mat-icon>manage_search</mat-icon>
        <span>NO AUDIT EVENTS FOUND</span>
      </div>

      <div class="aa-row" *ngFor="let audit of audits; trackBy: trackItem">

        <!-- timestamp -->
        <div class="aa-col aa-col--date">
          <span class="aa-timestamp">{{ audit.date | date: 'd MMM yy' }}</span>
          <span class="aa-time">{{ audit.date | date: 'HH:mm:ss' }}</span>
        </div>

        <!-- agent -->
        <div class="aa-col aa-col--user">
          <app-user-template class="aa-user-tpl" [user]="audit.user" tooltipField="userData.status">
          </app-user-template>
        </div>

        <!-- roles -->
        <div class="aa-col aa-col--roles">
          <span class="aa-role-chip" *ngFor="let role of audit.user?.roles">
            {{ role | replaceUnderscores: ' ' | lowercase }}
          </span>
        </div>

        <!-- activity -->
        <div class="aa-col aa-col--activity">
          <span class="aa-activity-badge">
            {{ 'ADMIN_AGENTS_AUDIT.ACTIVITIES.' + audit.activity | translate }}
          </span>
        </div>

        <!-- actions -->
        <div class="aa-col aa-col--actions">
          <button class="aa-action-btn" mat-icon-button
                  [matMenuTriggerFor]="auditMenu"
                  [matTooltip]="'ADMIN_AGENTS_AUDIT.ACTIONS_MENU.TITLE' | translate">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #auditMenu="matMenu">
            <button mat-menu-item (click)="openMetaData(audit.metaData)">
              <mat-icon>pageview</mat-icon>
              {{ 'ADMIN_AGENTS_AUDIT.ACTIONS_MENU.META_DATA_TITLE' | translate }}
            </button>
            <button mat-menu-item *ngIf="audit?.metaData?.conversationId"
                    (click)="openConversation(audit?.metaData?.conversationId)">
              <mat-icon>forum</mat-icon>
              {{ 'ADMIN_AGENTS_AUDIT.ACTIONS_MENU.CONVERSATION_TITLE' | translate }}
            </button>
          </mat-menu>
        </div>

      </div>
    </div>

    <!-- load more -->
    <div class="aa-load-more" *ngIf="lastKey">
      <button class="aa-btn aa-btn--ghost" type="button"
              (click)="findAudits(true)" [disabled]="isLoadingAudits">
        <mat-icon>expand_more</mat-icon>
        <span>{{ 'BUTTON.LOAD_MORE' | translate }}</span>
      </button>
    </div>

    <!-- error -->
    <div class="aa-error-banner" *ngIf="errorMessage">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

  </div>

</div>
